export default "__VITE_ASSET__EFaHqX2s__"